import React from "react";
import Bredcrumb from "../Bredcrumb/Main";
import Img from "../../assets/images/background/banner-image-5.jpg";

const OPEN_POSITIONS = [
  {
    id: 1,
    title: "Host / Hostess / Support Staff",
    location: "Canmore",
    positionType: "Part-time",
    wage: "$15–$16 per hour plus tips",
    hours: "6–20 hours per week",
    intro:
      "Be the smile that starts the experience! Are you friendly, organized, and love making people feel welcome? We're looking for a Part-Time Host/Hostess to be the first point of contact for our guests and help set the tone for a great dining experience. If you enjoy hospitality, teamwork, and a fast-paced environment, this could be a perfect fit.",
    sections: [
      {
        heading: "What you'll do",
        items: [
          "Greet and welcome guests as they arrive, manage reservations and seating to keep service flowing smoothly",
          "Provide menus and share daily specials or promotions",
          "Assist with food and beverages when needed",
          "Maintain cleanliness and organization of the host stand and dining area",
          "Answer phone calls and take reservations with proper phone etiquette",
          "Collaborate closely with servers and kitchen staff to ensure timely service",
        ],
      },
      {
        heading: "What we're looking for",
        items: [
          "A friendly, guest-focused attitude with a passion for hospitality",
          "Strong communication skills",
          "Comfortable using iPads and POS systems (TouchBistro experience is a plus)",
          "Ability to multitask in a fast-paced environment",
          "Attention to detail, and a positive team-oriented mindset",
          "Previous restaurant experience is beneficial but not required",
        ],
      },
      {
        heading: "Position details",
        content:
          "Part-time position. Must be available weekends and holidays. Plus tips! If you're excited about creating welcoming, memorable experiences for guests, we'd love to hear from you! Apply today and join our team!",
      },
    ],
  },
  {
    id: 2,
    title: "Line Cook",
    location: "Canmore, Alberta",
    positionType: "Full-Time, Permanent",
    wage: "$24.50 – $26.50 per hour (to be negotiated)",
    hours: "30–40 hours per week",
    startDate: "As soon as possible",
    intro:
      "Chez François All Day Breakfast & Lunch is seeking a reliable and motivated Line Cook to join our team in Canmore. The ideal candidate thrives in a fast-paced environment, takes pride in quality food preparation, and works well as part of a team.",
    sections: [
      {
        heading: "Key Responsibilities",
        items: [
          "Plan menus and estimate food requirements for their realization",
          "Requisition food and kitchen supplies",
          "Prepare and cook complete meals or individual dishes",
          "Prepare dishes for customers with food allergies or intolerances",
          "Supervise kitchen staff and helpers",
          "Maintain inventory and records of food, supplies, and equipment",
          "Clean kitchen and work areas",
          "Organize buffets and banquets as required",
        ],
      },
      {
        heading: "Qualifications",
        items: [
          "Secondary (high) school graduation certificate",
          "1 year to less than 2 years of experience in a restaurant setting",
          "English or French language proficiency",
        ],
      },
      {
        heading: "Work Environment",
        items: [
          "On-site position (no remote work option)",
          "Fast-paced and physically demanding environment",
          "Standing for extended periods",
          "Repetitive tasks and attention to detail required",
          "Ability to work under pressure",
          "Willingness to relocate considered an asset",
        ],
      },
      {
        heading: "Personal Attributes",
        items: ["Client-focused", "Organized", "Team player"],
      },
    ],
  },
  {
    id: 3,
    title: "Catering Supervisor",
    location: "Canmore, AB",
    positionType: "Seasonal / Full-time",
    wage: "$19.00 per hour + gratuities",
    hours: "Flexible, including weekends",
    applyEmail: "restaurantchezfrancois@gmail.com",
    applyAttn: "Dominik Gouin",
    intro:
      "Chez François is seeking a motivated and organized Catering Supervisor to join our team as we head into a busy season of events and off-site catering. This role is ideal for someone with strong front-of-house experience who is ready to take on more responsibility in planning, coordinating, and executing catering services.",
    sections: [
      {
        heading: "Key Responsibilities",
        items: [
          "Oversee catering events from setup to execution",
          "Coordinate with kitchen and front-of-house teams to ensure smooth service",
          "Act as the main point of contact for catering clients on event days",
          "Assist with planning, logistics, and event preparation",
          "Ensure high standards of service and presentation are maintained",
          "Help manage staffing and delegate tasks during events",
        ],
      },
      {
        heading: "Requirements",
        items: [
          "Previous serving or hospitality experience (supervisory experience is an asset)",
          "Strong organizational and communication skills",
          "Ability to lead a team in a fast-paced environment",
          "Flexible availability, including weekends",
          "Positive attitude and attention to detail",
        ],
      },
      {
        heading: "What We Offer",
        items: [
          "Competitive hourly wage: $19.00 per hour + gratuities",
          "Growth opportunity into event and operations management",
          "Supportive and team-oriented environment",
          "Work in a well-established, locally loved restaurant in Canmore",
        ],
      },
      {
        heading: "How to Apply",
        content:
          "Please send your resume to restaurantchezfrancois@gmail.com. Attn: Dominik Gouin.",
      },
    ],
  },
];

function mailtoHref(position) {
  const email = position.applyEmail || "info@chezfrancoiscanmore.ca";
  const subject = encodeURIComponent(
    `Application - ${position.title} - Chez François`
  );
  const body =
    position.applyAttn != null
      ? `&body=${encodeURIComponent(`Attn: ${position.applyAttn}\n\n`)}`
      : "";
  return `mailto:${email}?subject=${subject}${body}`;
}

function OpenPositions() {
  return (
    <>
      <Bredcrumb
        subtitle="Join Our Team"
        title="Careers at Chez François"
        Img={Img}
      />
      <section className="fluid-section careers-section">
        <div className="outer-container">
          <div className="sec-title centered" style={{ paddingTop: "1.5rem" }}>
            <div className="col-12">
              <h2>Open Positions</h2>
              <div className="text">
                Love food and people? Come work with us at Chez François.
              </div>
            </div>
          </div>
          <div className="row clearfix">
            {OPEN_POSITIONS.map((position) => (
              <div key={position.id} className="col-12">
                <div
                  className="inner wow fadeInUp position-card"
                  data-wow-duration="1500ms"
                  data-wow-delay="0ms"
                  style={{
                    marginBottom: "3rem",
                    padding: "2.5rem",
                    background: "var(--color-five, #f8f5f0)",
                    borderRadius: "8px",
                  }}
                >
                  <div className="content-box">
                    <h3 style={{ marginBottom: "0.5rem" }}>{position.title}</h3>
                    <div
                      className="text"
                      style={{
                        opacity: 0.9,
                        marginBottom: "1.5rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.35rem",
                      }}
                    >
                      <span>
                        <strong>Location:</strong> {position.location}
                      </span>
                      <span>
                        <strong>Position Type:</strong> {position.positionType}
                      </span>
                      <span>
                        <strong>Wage:</strong> {position.wage}
                      </span>
                      <span>
                        <strong>Hours:</strong> {position.hours}
                      </span>
                      {position.startDate && (
                        <span>
                          <strong>Start Date:</strong> {position.startDate}
                        </span>
                      )}
                    </div>
                    {position.intro && (
                      <div className="text" style={{ marginBottom: "1.5rem" }}>
                        {position.intro}
                      </div>
                    )}
                    {position.sections?.map((section, i) => (
                      <div key={i} style={{ marginBottom: "1.5rem" }}>
                        <h4
                          style={{
                            fontSize: "1.15rem",
                            marginBottom: "0.75rem",
                          }}
                        >
                          {section.heading}
                        </h4>
                        {section.items ? (
                          <ul
                            className="text"
                            style={{
                              marginLeft: "1.25rem",
                              marginBottom: 0,
                            }}
                          >
                            {section.items.map((item, j) => (
                              <li key={j} style={{ marginBottom: "0.35rem" }}>
                                {item}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <div className="text" style={{ marginBottom: 0 }}>
                            {section.content}
                          </div>
                        )}
                      </div>
                    ))}
                    <div className="link-box" style={{ marginTop: "2.5rem" }}>
                      <a
                        href={mailtoHref(position)}
                        className="theme-btn btn-style-two clearfix"
                      >
                        <span className="btn-wrap">
                          <span className="text-one">Apply via Email</span>
                          <span className="text-two">Apply via Email</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="col-12">
              <p className="text" style={{ textAlign: "center", marginTop: "1rem", opacity: 0.9 }}>
                We thank all applicants for their interest. However, only those selected for an interview will be contacted.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OpenPositions;
